var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCurvedArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 9,
    viewBox: "0 0 12 9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "evenodd",
    d: "M6.459 8.388a.52.52 0 01-.721-.065.494.494 0 01-.119-.32V6.001c-2.607.001-4.202.883-4.778 2.708A.426.426 0 01.432 9 .43.43 0 010 8.557c.134-3.714 1.971-5.872 5.62-6.054V.5c0-.276.229-.5.511-.5.12 0 .236.041.328.116l4.607 3.751a.492.492 0 010 .769L6.459 8.388z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurvedArrow);
export default ForwardRef;